var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgForward1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 28,
    viewBox: "0 0 37 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 23.4375,
    width: 19,
    height: 19,
    transform: "rotate(-180 20 23.4375)",
    stroke: "black",
    strokeWidth: 1.60714
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6424 6.59375L35.0312 14.0156M35.0312 14.0156L27.6424 21.4375M35.0312 14.0156L19 14.0156",
    stroke: "black",
    strokeWidth: 3.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "filled",
    d: "M12.3721 20H9.83203V10.209L6.79981 11.1494V9.08399L12.0996 7.18555H12.3721V20Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgForward1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Forward1.76abab0e92751f7209971049338ee26d.svg";